import React from "react";

import { getBaseUnits } from "utils/fields";
import convertUnit from "utils/convertUnit";
import { useStateSelector } from "utils/field";

import sharedClasses from "../../style.module.scss";

export default React.memo(({ accessor }) => {
    const supplyFlow = useStateSelector(`${accessor}.supplyFlowrate`) || 0;
    const exhaustFlow = useStateSelector(`${accessor}.exhaustFlowrate`) || 0;

    const supplyUnits = useStateSelector(`${accessor}.supplyFlowrate_u`);
    const exhaustUnits = useStateSelector(`${accessor}.exhaustFlowrate_u`);
    const modelUnits = useStateSelector(`model.modelData.uiSettings.primaryUnits`);

    const { trueBase: supplyBase, displayBase: supplyDisplay } = getBaseUnits("hrvSupply", modelUnits);
    const { trueBase: exhaustBase, displayBase: exhaustDisplay } = getBaseUnits("hrvExhaust", modelUnits);

    const supplyU = supplyUnits || supplyDisplay || supplyBase;
    const exhaustU = exhaustUnits || exhaustDisplay || exhaustBase;

    const supply = `${parseFloat(
        convertUnit({
            value: supplyFlow,
            type: "airFlow",
            inputUnit: supplyBase,
            outputUnit: supplyU,
        })
    ).toFixed(1)}${supplyU}`;
    const exhaust = `${parseFloat(
        convertUnit({
            value: exhaustFlow,
            type: "airFlow",
            inputUnit: exhaustBase,
            outputUnit: exhaustU,
        })
    ).toFixed(1)}${exhaustU}`;

    return (
        <div className={sharedClasses.stats} style={{ gridTemplateColumns: "1fr 1fr 1fr" }}>
            <span>
                <strong>S:</strong> {supply}
            </span>
            <span>
                <strong>E:</strong> {exhaust}
            </span>
        </div>
    );
});
